import React, { useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../assets/css/DesktopFilter.css';

function CustomToggle({ children, eventKey, callback, isOpen }) {
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    callback && callback(eventKey)
  );
  return (
    <div className="custom-header" onClick={decoratedOnClick}>
      <span className="custom-title">{children}</span>
      <span className="toggle-icon">{isOpen ? '-' : '+'}</span>
    </div>
  );
}

function FilterDesktop() {
  const sections = [
    { title: 'Category', items: ['Batch Care', 'Dustbin', 'Yogamat', 'Carpet', 'Toilet Brush','Batch Care', 'Dustbin', 'Yogamat', 'Carpet', 'Toilet Brush', 'Yogamat', 'Carpet', 'Toilet Brush'] },
    { title: 'Color', items: ['Blue', 'Green', 'Yellow', 'Pink', 'Orange', 'White'] },
    { title: 'Size', items: ['11x12', '14x34', '200x1000', '50x1200', '400x300', '900x234'] },
  ];

  const initialKeys = sections.map((_, index) => String(index)); // ['0', '1', '2']
  const [activeKeys, setActiveKeys] = useState(initialKeys);
  const handleToggle = (key) => {
    setActiveKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  return (
    <div className="Filter-according">
      <Accordion activeKey={activeKeys} alwaysOpen>
        {sections.map((section, index) => {
          const eventKey = String(index);
          return (
            <Accordion.Item eventKey={eventKey} key={index}>
              <div className="custom-accordion-header-wrapper">
                <CustomToggle
                  eventKey={eventKey}
                  callback={handleToggle}
                  isOpen={activeKeys.includes(eventKey)}
                >
                  {section.title}
                </CustomToggle>
              </div>
              <Accordion.Body>
                <div className='new'>
                  <div className="checkboxes">
                    <div className="checkboxes__row">
                      {section.items.map((item, i) => (
                        <div className="checkboxes__item" key={i}>
                          <label className="checkbox style-c">
                            <input type="checkbox" />
                            <div className="checkbox__checkmark" />
                            <div className="checkbox__body">{item}</div>
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </div>
  );
}
export default FilterDesktop;
